import { render, staticRenderFns } from "./nonCtcComponentHistory.vue?vue&type=template&id=52a4b813&scoped=true"
import script from "./nonCtcComponentHistory.vue?vue&type=script&lang=js"
export * from "./nonCtcComponentHistory.vue?vue&type=script&lang=js"
import style0 from "./nonCtcComponentHistory.vue?vue&type=style&index=0&id=52a4b813&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a4b813",
  null
  
)

export default component.exports